import {
  defaultIncentiveWizard,
  IncentiveWizard,
  IncentiveWizardState,
} from '@components/incentives/create-incentive-wizard';
import { Head } from '@components/head';
import { ActionBar } from '@components/ui/action-bar';
import { CollectionTypeEnum, HostedCampaign } from '@givz/core-client';
import { useData } from '@hooks/form';
import { useCreateGenerator } from '@queries/incentives';
import { Button, Container, Grid } from '@mui/material';
import { routes } from '@routes';
import { useSnackbar } from 'notistack';
import { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';

export const AddIncentivePage: FunctionComponent = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const createGeneratorMutation = useCreateGenerator({ onSuccess });
  const incentiveWizardUseData = useData<IncentiveWizardState>(
    defaultIncentiveWizard(),
  );

  const { data } = incentiveWizardUseData;

  function onSuccess(responseData: HostedCampaign) {
    const { name } = responseData;
    navigate(routes.incentives);
    enqueueSnackbar(`The incentive ${name} was created successfully.`, {
      variant: 'success',
    });
  }

  const onClickCreate = () => {
    createGeneratorMutation.mutate({
      hostedCampaignGeneratorCreate: {
        amount: Number(data.offer),
        name: data.name,
        ...(data.featuredCharitiesType === CollectionTypeEnum.Handpicked && {
          collection: {
            organizationGids: Array.from(data.selectedCharities.values()).map(
              ({ gid }) => gid,
            ),
          },
        }),
      },
    });
  };

  const disabled =
    data.name === '' ||
    data.offer === 0 ||
    (data.featuredCharitiesType === CollectionTypeEnum.Handpicked &&
      data.selectedCharities.size === 0);

  return (
    <>
      <Head title="Add Incentive" />
      <Container maxWidth="xl">
        <ActionBar
          title="Add Incentive"
          primaryAction={
            <Button onClick={onClickCreate} disabled={disabled}>
              Create
            </Button>
          }
        />
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <IncentiveWizard
              useData={incentiveWizardUseData}
              errors={createGeneratorMutation?.data?.errors}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};
